export default __webpack_public_path__ + "static/media/health-insurance-benefit.30bc2a76.png";